import { SdgUnitsMode } from '@upright/common/model/output/scores/sdg-alignment/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';
import { SdgLegend } from '@upright/ui/common/upright/model/output/scores/sdg-alignments/sdg-legend';
import styled from 'styled-components';
import { AllSdgAlignments } from './all-sdg-alignments';
import { SdgAlignmentsContext, SdgAlignmentsContextProvider } from './context';
import { SdgHeader } from './sdg-header';
import { SdgModelVersionText } from './sdg-model-version-text';
import { SdgRenderViewButton } from './sdg-render-view-button';

export interface SdgAlignmentsProps {
  context: SdgAlignmentsContext;
}

export const SdgAlignments = (props: SdgAlignmentsProps) => {
  const context = props.context;
  const { viewOptions } = context;
  return (
    <SdgAlignmentsContextProvider value={context}>
      <Root showBottomBorder={!!viewOptions.showBottomBorder}>
        {viewOptions.unitsMode === SdgUnitsMode.PURE_REVENUE_SHARES && <SdgLegend />}
        <SdgHeader />
        <AllSdgAlignments />
      </Root>
      {!viewOptions.hideRenderViewButton && <SdgRenderViewButton />}
      {viewOptions.showModelVersionText && <SdgModelVersionText />}
    </SdgAlignmentsContextProvider>
  );
};

const Root = styled.div<{ showBottomBorder: boolean }>`
  font-size: ${themeGet('fontSizes.1')};
  width: 100%;
  border-bottom: ${props => props.showBottomBorder && `1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY}`};
`;
